import { useRouteError } from "react-router-dom";

export function ErrorPage() {
  const error:any = useRouteError();
  

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, comunicate con Joao Castillo.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}